import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// ── 401 interceptor ──────────────────────────────────────────────────────────
// When the access-token cookie is missing or expired the backend returns
// 401 "Not authenticated" / "Token expired".  Rather than letting that
// surface as a confusing toast, redirect to /login so the user can
// re-authenticate.  Auth-specific routes are excluded to avoid loops.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err?.config?.url || "";
      const isAuthRoute = url.includes("/auth/me") || url.includes("/auth/login");
      if (!isAuthRoute) {
        // Preserve the page they were on so we can send them back after login
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?next=${next}`;
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join("; ");
  return JSON.stringify(d);
}

export default api;
